<template>
  <div class="container">
    <h3>In Your Store</h3>
    <FeaturedProducts :max="max" />
  </div>
</template>

<script>
import FeaturedProducts from './components/FeaturedProducts.vue'
import store from './store'

export default {
  store,
  name: 'App',
  data() {
    return { }
  },
  props: {
    max: Number
  },
  components: {
    FeaturedProducts
  },
  async created() {
    this.$dataLayer.push({ 'event': 'pcefp.loaded', pcefp: { max: this.max }})
  }
}
</script>

<style scoped>
@import "./assets/app.css";
.container {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
.container h3 {
  font-size: 18px;
  color: #444444;
  margin-bottom: 8px;
}
@media only screen and (max-width: 768px) { 
  .container h3 {
    padding-left: 10px;
  }
}
</style>
